<template>
  <div class="materia-card card mb-3 shadow-sm">
    <div class="card-body">
      <!-- Cabecera -->
      <div class="d-flex justify-content-between align-items-start flex-wrap">
        <div class="mb-2">
          <h5 class="mb-1 text-wrap text-materia-dark">{{ materia.tipo || 'Sin tipo' }}</h5>
          <div class="text-muted small">
            Código:
            <span class="badge bg-materia-light text-materia-dark">{{ materia.codigo }}</span>
            <button class="btn btn-sm btn-icon" @click="$emit('copiar', materia.codigo)" title="Copiar código">
              <font-awesome-icon icon="copy" />
            </button>
          </div>
        </div>

        <div class="dropdown text-end ms-auto">
          <button class="btn btn-sm btn-light" type="button" data-bs-toggle="dropdown">
            <font-awesome-icon icon="ellipsis-v" />
          </button>
          <ul class="dropdown-menu dropdown-menu-end">
            <li><a class="dropdown-item" href="#" @click.prevent="$emit('editar', materia)">Ajustar Cantidad</a></li>
            <li><a class="dropdown-item" href="#" @click.prevent="$emit('procesar', materia)">Procesar</a></li>
            <li><a class="dropdown-item" href="#" @click.prevent="$emit('transformar', materia)">Transformar a Producto Final Bulk</a></li>
            <li><a class="dropdown-item" href="#" @click.prevent="verArbol = true">Ver Trazabilidad</a></li>
            <li><a class="dropdown-item" href="#" @click.prevent="toggleDetalles">
              {{ mostrarDetalles ? 'Ocultar Detalles' : 'Ver Detalles' }}
            </a></li>
          </ul>
        </div>
      </div>

      <!-- Info básica -->
      <div class="mt-2 small text-wrap">
        <div><strong>Cantidad inicial:</strong> {{ materia.cantidad }} {{ materia.unidad_medida }}</div>
        <div>
          <strong>Stock disponible:</strong> 
          <span :class="{ 'text-danger': materia.stock_disponible < 0, 'text-success': materia.stock_disponible >= 0 }">
            {{ materia.stock_disponible }} {{ materia.unidad_medida }}
          </span>
        </div>

        <!-- Origen -->
        <div v-if="materia.biomasa" class="mt-2">
          <font-awesome-icon icon="leaf" class="text-success me-1" />
          Biomasa: <strong>{{ materia.biomasa.tipo_biomasa }}</strong>
          <small class="text-muted">({{ formatDate(materia.biomasa.fecha_cosecha) }})</small>
          <button class="btn btn-sm btn-icon" @click="$emit('copiar', materia.biomasa.codigo || 'NO_CODIGO')" title="Copiar código biomasa">
            <font-awesome-icon icon="copy" />
          </button>
        </div>

        <div v-else-if="materia.procesos_resultado?.length" class="mt-2">
          <font-awesome-icon icon="recycle" class="text-warning me-1" />
          Materia Prima Origen:
          <strong>{{ materia.procesos_resultado[0].proceso_transformacion.insumos[0].materia_prima.codigo }}</strong>
          <button class="btn btn-sm btn-icon"
            @click="$emit('copiar', materia.procesos_resultado[0].proceso_transformacion.insumos[0].materia_prima.codigo)"
            title="Copiar código origen">
            <font-awesome-icon icon="copy" />
          </button>
        </div>
      </div>

      <!-- Detalles opcionales -->
      <div v-if="mostrarDetalles" class="detalles mt-3 bg-light p-2 rounded">
        <div>Fecha Secado: {{ materia.fecha_fin_secado ? formatDate(materia.fecha_fin_secado) : '-' }}</div>
        <div>Humedad: {{ materia.humedad_porcentaje ?? '-' }}%</div>
      </div>

      <!-- Modal de trazabilidad -->
      <div v-if="verArbol" class="modal fade show d-block" tabindex="-1" style="background-color: rgba(0,0,0,0.5);">
        <div class="modal-dialog modal-lg modal-dialog-scrollable">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Trazabilidad - {{ materia.codigo }}</h5>
              <button type="button" class="btn-close" @click="verArbol = false"></button>
            </div>
            <div class="modal-body p-0">
              <TrazabilidadBuscador :codigo-inicial="materia.codigo" />
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" @click="verArbol = false">Cerrar</button>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { format } from 'date-fns';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import TrazabilidadBuscador from '@/components/Trazabilidad/TrazabilidadBuscador.vue';

export default {
  name: 'MateriaPrimaCard',
  props: ['materia'],
  components: { FontAwesomeIcon, TrazabilidadBuscador },
  data() {
    return {
      mostrarDetalles: false,
      verArbol: false
    };
  },
  methods: {
    formatDate(date) {
      return format(new Date(date), 'dd/MM/yyyy');
    },
    toggleDetalles() {
      this.mostrarDetalles = !this.mostrarDetalles;
    }
  }
};
</script>

<style scoped>
.materia-card {
  border-radius: 0.75rem;
  transition: box-shadow 0.3s ease;
}
.materia-card:hover {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.08);
}

.text-materia-dark {
  color: #a84e1a;
}
.bg-materia-light {
  background-color: #f9ece4;
}

.badge {
  font-size: 0.75rem;
}
.detalles {
  font-size: 0.85rem;
}
.btn-icon {
  background: none;
  border: none;
  padding: 0;
  margin-left: 6px;
  color: #6c757d;
}
.btn-icon:hover {
  color: #000;
}
.modal-body {
  max-height: 70vh;
  overflow-y: auto;
}
</style>
